import React from 'react';

import { Link, LinkProps, Message, Text } from '@atoms';

import classes from './footer-link.module.scss';

export type FooterLinkProps = {
  secondary?: boolean;
  message: Message;
} & Omit<LinkProps, 'classes' | 'children'>;

export const FooterLink = ({
  secondary,
  message,
  ...props
}: FooterLinkProps) => {
  return (
    <Link className={classes.footerLink} {...props}>
      <Text
        margin={0}
        type="reduced"
        fontWeight={!secondary ? 'bold' : 'normal'}
        message={message}
      />
    </Link>
  );
};
